import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageFooterMenu() {
  const [footerSections, setFooterSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemID, setItemID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({
    sectionName: "",
    heading: "",
    subHeadings: [""],
  });

  // Function to show details in popup
  const showDetailsPopup = (
    sectionName,
    heading,
    subHeadings,
    title = "Footer Section Details"
  ) => {
    const subHeadingsHtml =
      subHeadings && subHeadings.length > 0
        ? subHeadings
            .map(
              (sub, index) =>
                `<div style="margin-bottom: 5px; padding: 5px 10px; background: #f8f9fa; border-radius: 3px;">
            ${index + 1}. ${sub || "No subheading"}
          </div>`
            )
            .join("")
        : '<p class="text-muted">No subheadings available</p>';

    Swal.fire({
      title: title,
      html: `
        <div style="text-align: left; max-height: 400px; overflow-y: auto; padding: 10px;">
          <h6 style="color: #333; margin-bottom: 10px;"><strong>Section Name:</strong></h6>
          <p style="white-space: pre-wrap; word-wrap: break-word; margin-bottom: 20px; padding: 10px; background: #f8f9fa; border-radius: 5px;">
            ${sectionName || "No section name available"}
          </p>
          <h6 style="color: #333; margin-bottom: 10px;"><strong>Heading:</strong></h6>
          <p style="white-space: pre-wrap; word-wrap: break-word; margin-bottom: 20px; padding: 10px; background: #f8f9fa; border-radius: 5px;">
            ${heading || "No heading available"}
          </p>
          <h6 style="color: #333; margin-bottom: 10px;"><strong>Sub Headings (${
            subHeadings?.length || 0
          }):</strong></h6>
          <div style="max-height: 200px; overflow-y: auto;">
            ${subHeadingsHtml}
          </div>
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false,
      width: "700px",
      customClass: {
        popup: "footer-menu-popup",
      },
    });
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Section Name",
      cell: (row) => {
        const sectionName = row.sectionName || "";
        const shortSectionName =
          sectionName.length > 20
            ? `${sectionName.substring(0, 20)}...`
            : sectionName;

        return (
          <div className="d-flex align-items-center">
            <span className="me-2">
              {shortSectionName || (
                <span className="text-muted">No section name</span>
              )}
            </span>
            {sectionName.length > 20 && (
              <button
                type="button"
                className="btn btn-sm p-0"
                onClick={() =>
                  showDetailsPopup(
                    row.sectionName,
                    row.heading,
                    row.subHeadings,
                    "Footer Section Details"
                  )
                }
                title="View full details"
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#007bff",
                  fontSize: "16px",
                }}
              >
                <i className="fa-solid fa-eye"></i>
              </button>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Heading",
      cell: (row) => {
        const heading = row.heading || "";
        const shortHeading =
          heading.length > 20 ? `${heading.substring(0, 20)}...` : heading;

        return (
          <div className="d-flex align-items-center">
            <span className="me-2">
              {shortHeading || <span className="text-muted">No heading</span>}
            </span>
            {heading.length > 20 && (
              <button
                type="button"
                className="btn btn-sm p-0"
                onClick={() =>
                  showDetailsPopup(
                    row.sectionName,
                    row.heading,
                    row.subHeadings,
                    "Footer Section Details"
                  )
                }
                title="View full details"
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#007bff",
                  fontSize: "16px",
                }}
              >
                <i className="fa-solid fa-eye"></i>
              </button>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Sub Headings",
      cell: (row) => {
        const subHeadings = row.subHeadings || [];
        const subHeadingCount = subHeadings.length;
        const firstSubHeading = subHeadings[0] || "";
        const shortSubHeading =
          firstSubHeading.length > 25
            ? `${firstSubHeading.substring(0, 25)}...`
            : firstSubHeading;

        return (
          <div className="d-flex align-items-center">
            <span className="me-2">
              {subHeadingCount > 0 ? (
                <>
                  <span className="badge bg-secondary me-2">
                    {subHeadingCount}
                  </span>
                  {shortSubHeading}
                </>
              ) : (
                <span className="text-muted">No subheadings</span>
              )}
            </span>
            {subHeadingCount > 0 && (
              <button
                type="button"
                className="btn btn-sm p-0"
                onClick={() =>
                  showDetailsPopup(
                    row.sectionName,
                    row.heading,
                    row.subHeadings,
                    "Footer Section Details"
                  )
                }
                title="View all subheadings"
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#007bff",
                  fontSize: "16px",
                }}
              >
                <i className="fa-solid fa-eye"></i>
              </button>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Created Date",
      selector: (row) =>
        new Date(
          row.createdAt || row.createdOn || row.updatedAt
        ).toLocaleDateString(),
      sortable: true,
      center: true,
      width: "130px",
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            onClick={() => handleEdit(row)}
            className="btn btn-sm me-2"
            style={{
              background: "transparent",
              border: "none",
              color: "rgb(133, 218, 79)",
            }}
          >
            <i className="fa-solid fa-pen-to-square fs-5"></i>
          </button>
          <button
            title="Delete"
            onClick={() => handleDelete(row._id)}
            className="btn btn-sm"
            style={{
              background: "transparent",
              border: "none",
              color: "#dc3545",
            }}
          >
            <i className="fa-solid fa-trash-can fs-5"></i>
          </button>
        </div>
      ),
      center: true,
      width: "120px",
    },
  ];

  // Fetch all footer sections
  const fetchFooterSections = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getFooterMenu();
      console.log("Footer sections data:", res.data);
      setFooterSections(res.data);
    } catch (error) {
      console.error("Error fetching footer sections:", error);
      toast.error("Failed to load footer sections!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFooterSections();
  }, []);

  // Handle edit button click
  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({
      sectionName: row.sectionName || "",
      heading: row.heading || "",
      subHeadings: row.subHeadings || [""],
    });
    setItemID(row._id);
  };

  // Handle subheading change in edit form
  const handleEditSubHeadingChange = (index, value) => {
    const newSubHeadings = [...editData.subHeadings];
    newSubHeadings[index] = value;
    setEditData({ ...editData, subHeadings: newSubHeadings });
  };

  const addEditSubHeading = () => {
    setEditData({
      ...editData,
      subHeadings: [...editData.subHeadings, ""],
    });
  };

  const removeEditSubHeading = (index) => {
    if (editData.subHeadings.length <= 1) {
      toast.error("At least one subheading is required");
      return;
    }

    const newSubHeadings = editData.subHeadings.filter((_, i) => i !== index);
    setEditData({ ...editData, subHeadings: newSubHeadings });
  };

  // Handle delete button click with SweetAlert confirmation
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Footer Section?",
      text: "Are you sure you want to delete this footer section?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteFooterMenu(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Footer section has been deleted.", "success");
          fetchFooterSections();
        } else {
          toast.error(res?.message || "Failed to delete footer section");
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete footer section.", "error");
      }
    }
  };

  // Handle form submission for update
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!editData.sectionName.trim()) {
      toast.error("Please enter section name.");
      return;
    }

    if (!editData.heading.trim()) {
      toast.error("Please enter heading.");
      return;
    }

    // Filter out empty subheadings
    const validSubHeadings = editData.subHeadings
      .map((sub) => sub.trim())
      .filter((sub) => sub !== "");

    if (validSubHeadings.length === 0) {
      toast.error("Please enter at least one subheading.");
      return;
    }

    try {
      // Prepare update data
      const data = {
        sectionName: editData.sectionName.trim(),
        heading: editData.heading.trim(),
        subHeadings: validSubHeadings,
      };

      console.log("Updating footer section with data:", data);

      const res = await HomeService.updateFooterMenu(itemID, data);

      if (res?.status) {
        toast.success("Footer section updated successfully!");
        setIsEdit(false);
        setEditData({ sectionName: "", heading: "", subHeadings: [""] });
        fetchFooterSections();
      } else {
        toast.error(res?.message || "Failed to update footer section.");
      }
    } catch (error) {
      toast.error("Failed to update footer section.");
      console.error("Error updating footer section:", error);
    }
  };

  // Handle cancel edit
  const handleCancel = () => {
    setIsEdit(false);
    setEditData({ sectionName: "", heading: "", subHeadings: [""] });
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit ? (
            <section className="chartBox_area">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">Edit Footer Section</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* Section Name Input */}
                      <div className="col-md-6 mt-3">
                        <label htmlFor="sectionName">
                          Section Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="sectionName"
                          className="form-control"
                          value={editData?.sectionName || ""}
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              sectionName: e.target.value,
                            }))
                          }
                          placeholder="e.g., Quick Links, Company, Support"
                          required
                        />
                        <small className="text-muted">
                          Internal reference name for this section
                        </small>
                      </div>

                      {/* Heading Input */}
                      <div className="col-md-6 mt-3">
                        <label htmlFor="heading">
                          Heading<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="heading"
                          className="form-control"
                          value={editData?.heading || ""}
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              heading: e.target.value,
                            }))
                          }
                          placeholder="e.g., Explore, Support, Company"
                          required
                        />
                        <small className="text-muted">
                          The main title displayed in the footer
                        </small>
                      </div>

                      {/* Sub Headings Section */}
                      <div className="col-md-12 mt-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <label className="mb-0">
                            Sub Headings<span className="text-danger">*</span>
                          </label>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={addEditSubHeading}
                            style={{
                              borderRadius: "8px",
                              padding: "5px 15px",
                              fontSize: "14px",
                            }}
                          >
                            <i className="fas fa-plus me-1"></i> Add More
                          </button>
                        </div>

                        {editData.subHeadings.map((subHeading, index) => (
                          <div key={index} className="input-group mb-3">
                            <input
                              type="text"
                              className="form-control"
                              value={subHeading}
                              onChange={(e) =>
                                handleEditSubHeadingChange(
                                  index,
                                  e.target.value
                                )
                              }
                              placeholder={`Subheading ${
                                index + 1
                              } (e.g., About Us, Contact)`}
                              required={index === 0}
                            />
                            {editData.subHeadings.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-outline-danger"
                                onClick={() => removeEditSubHeading(index)}
                                style={{
                                  borderTopLeftRadius: "0",
                                  borderBottomLeftRadius: "0",
                                }}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            )}
                          </div>
                        ))}

                        <small className="text-muted">
                          Enter individual menu items/links for this footer
                          section
                        </small>
                      </div>
                    </div>

                    <div className="mt-4 pt-3 border-top">
                      <button
                        type="submit"
                        className="btn btn-primary me-3"
                        style={{
                          background: "rgb(133, 218, 79)",
                          border: "none",
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-floppy-disk me-2"></i>
                        Save Changes
                      </button>
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="btn btn-secondary"
                        style={{
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-times me-2"></i>
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          ) : (
            <>
              <div className="mt-5">
                <div style={headLineStyle} className="page-headline">
                  Manage Footer Sections
                </div>
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading footer sections...</p>
                  </div>
                ) : footerSections.length > 0 ? (
                  <div className="card">
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={footerSections}
                        pagination
                        responsive
                        highlightOnHover
                        striped
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        noDataComponent={
                          <div className="text-center py-4">
                            <i className="fa-solid fa-sitemap fa-2x text-muted mb-3"></i>
                            <p>No footer sections found</p>
                          </div>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="card">
                    <div className="card-body text-center py-5">
                      <i className="fa-solid fa-sitemap fa-3x text-muted mb-3"></i>
                      <h5>No Footer Sections Available</h5>
                      <p className="text-muted">
                        There are no footer sections to display at the moment.
                      </p>
                      <a
                        href="/add-footer-menu"
                        className="btn btn-primary mt-2"
                        style={{
                          background: "rgb(133, 218, 79)",
                          border: "none",
                        }}
                      >
                        <i className="fa-solid fa-plus me-2"></i>
                        Add New Footer Section
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Add CSS for the popup */}
      <style>
        {`
          .footer-menu-popup .swal2-popup {
            max-width: 700px;
          }
          .footer-menu-popup .swal2-html-container {
            overflow: hidden;
          }
        `}
      </style>
    </>
  );
}

export default ManageFooterMenu;
